import * as React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Chip, Select, Tab, Tabs, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import authService from '../api-authorization/AuthorizeService'
import StyledActionButton from "../GreenButton";
export default function FormDialog({cb}) {
    const defaultSuccessMessage = "Channel subscribed successfully.";
    const defaultErrorMessage = "Channel could not be added at this time. Try again later.";

    const [open, setOpen] = React.useState(false);
    const [channelType, setChannelType] = React.useState("YouTube");
    const [url, setUrl] = React.useState("")
    const [bulkUrls, setBulkUrls] = React.useState("")
    const [mode, setMode] = React.useState("single");
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [submitResult, setSubmitResult] = React.useState(null);
    const [bulkReport, setBulkReport] = React.useState(null);

    
    const handleClickOpen = async () => {
        setSubmitResult(null);
        setBulkReport(null);
        setOpen(true);
    };

    const handleClose = () => {
        if (isSubmitting) {
            return;
        }
        setOpen(false);
        setSubmitResult(null);
        setBulkReport(null);
    };
    
    const handleChange = (newChips) => {
        setUrl(newChips.target.value)
    }
    const handleSelectChange = (e) => {
        setChannelType(e.target.value)
    }
    const handleModeChange = (event, newMode) => {
        setMode(newMode);
        setSubmitResult(null);
        setBulkReport(null);
    }
    const handleBulkChange = (event) => {
        setBulkUrls(event.target.value);
    }
   
    const create = async () => { 
        setIsSubmitting(true);
        setSubmitResult(null);
        setBulkReport(null);

        var req = {
            type: channelType,
            channelurl: url
        }
        try {
            const response = await fetch('/api/channels?2', {
                method: "POST",
                headers: {/*'X-Authorization': `Bearer ${token}`,*/ 'Content-Type': 'application/json' },
                body: JSON.stringify(req)
            });

            authService.followIfLoginRedirect(response);

            let message = response.ok ? defaultSuccessMessage : defaultErrorMessage;
            try {
                const data = await response.json();
                if (typeof data === "string" && data) {
                    message = data;
                }
            } catch {
            }

            if (!response.ok) {
                throw new Error(message || defaultErrorMessage);
            }

            setSubmitResult({ severity: "success", message });
            setUrl("");
            cb();
        } catch (error) {
            setSubmitResult({
                severity: "warning",
                message: error?.message || defaultErrorMessage
            });
        } finally {
            setIsSubmitting(false);
        }
    }

    const bulkCreate = async () => {
        setIsSubmitting(true);
        setSubmitResult(null);
        setBulkReport(null);

        try {
            const response = await fetch('/api/channels/bulk', {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ channels: bulkUrls })
            });

            authService.followIfLoginRedirect(response);

            const data = await response.json();
            if (!response.ok) {
                throw new Error(typeof data === "string" ? data : defaultErrorMessage);
            }

            setBulkReport(data);
            setSubmitResult({
                severity: data.rejected_count > 0 ? "warning" : "success",
                message: `${data.added_count} added, ${data.already_subscribed_count} already subscribed, ${data.rejected_count} rejected.`
            });
            if (data.accepted_count > 0) {
                cb();
            }
        } catch (error) {
            setSubmitResult({
                severity: "warning",
                message: error?.message || defaultErrorMessage
            });
        } finally {
            setIsSubmitting(false);
        }
    }

    const renderBulkReport = () => {
        if (!bulkReport?.results?.length) {
            return null;
        }

        return (
            <Box sx={{ mt: 2, maxHeight: 260, overflow: 'auto', border: '1px solid #e0e0e0', borderRadius: 1 }}>
                {bulkReport.results.map((row) => (
                    <Box
                        key={`${row.line_number}-${row.input}`}
                        sx={{
                            px: 1.5,
                            py: 1,
                            borderBottom: '1px solid #eee',
                            display: 'grid',
                            gridTemplateColumns: '64px 120px 1fr',
                            gap: 1,
                            alignItems: 'start'
                        }}
                    >
                        <Typography variant="caption">Line {row.line_number}</Typography>
                        <Chip
                            size="small"
                            label={row.status.replace('_', ' ')}
                            color={row.status === "rejected" ? "error" : row.status === "already_subscribed" ? "default" : "success"}
                        />
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>{row.input}</Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                {row.message}{row.type ? ` ${row.type} / ${row.handle}` : ""}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
        );
    }
    
    return (
        <div>
            <StyledActionButton onClick={handleClickOpen}>
                Create 
            </StyledActionButton>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
                <DialogTitle>Subscribe to Channel</DialogTitle>
                <DialogContent>
                    <Tabs value={mode} onChange={handleModeChange} sx={{ mb: 2 }}>
                        <Tab value="single" label="Single" />
                        <Tab value="bulk" label="Bulk add" />
                    </Tabs>

                    {mode === "single" && (
                        <>
                        <Select fullWidth
                            value={channelType}
                            label="Channel Source"
                            onChange={handleSelectChange}
                        >
                            <MenuItem value={"YouTube"}>YouTube</MenuItem>
                            <MenuItem value={"TikTok"}>TikTok</MenuItem>
                            <MenuItem value={"TelegramPublic"}>Telegram (Public Channel)</MenuItem>
                        </Select>
                    
                    <DialogContentText className="mt-3">
                        Enter the URL for the channel
                    </DialogContentText>
                    
                    <TextField margin="dense" label="URL" variant="standard" fullWidth={true} value={url} onChange={handleChange} />
                        </>
                    )}
                    {mode === "bulk" && (
                        <>
                            <DialogContentText>
                                Paste one channel URL per line. Supported channels will be detected automatically.
                            </DialogContentText>
                            <TextField
                                margin="dense"
                                label="Channel URLs"
                                variant="outlined"
                                fullWidth
                                multiline
                                minRows={8}
                                value={bulkUrls}
                                onChange={handleBulkChange}
                            />
                        </>
                    )}
                    {isSubmitting && mode === "bulk" && (
                        <Alert severity="info" icon={<CircularProgress size={18} color="inherit" />} sx={{ mt: 2 }}>
                            Bulk adding channels. This can take a while for large lists.
                        </Alert>
                    )}
                    {submitResult && (
                        <Alert severity={submitResult.severity} sx={{ mt: 2 }}>
                            {submitResult.message}
                        </Alert>
                    )}
                    {renderBulkReport()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} disabled={isSubmitting}>
                        {submitResult?.severity === "success" ? "Close" : "Cancel"}
                    </Button>
                    <Button
                        onClick={mode === "single" ? create : bulkCreate}
                        disabled={isSubmitting || (mode === "single" ? !url.trim() : !bulkUrls.trim())}
                        startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
                    >
                        {isSubmitting ? (mode === "bulk" ? "Bulk adding..." : "Creating...") : "Create"}
                    </Button>
                </DialogActions>
            </Dialog>
            
        </div>
    );
}
